var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultiJoystick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "multi-joystick"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8876 30.9626H25.5309C26.3144 30.9626 26.9505 31.5988 26.9505 32.3823V32.9795H13.468V32.3823C13.468 31.5988 14.1041 30.9626 14.8876 30.9626Z",
    fill: "#D1D1D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.7699 32.9832H27.6486C28.4023 32.9832 29.0142 33.5951 29.0142 34.3488V35H11.4043V34.3488C11.4043 33.5951 12.0162 32.9832 12.7699 32.9832Z",
    fill: "#D1D1D5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.8158 7.09619H14.0246C13.9587 7.24802 13.9363 7.4091 13.9688 7.56977L15.3243 14.278C15.5229 15.2608 15.6226 16.2524 15.6226 17.2452V23.3237C15.6226 23.9246 16.3098 24.4118 17.1574 24.4118H22.9411C23.7901 24.4118 24.4777 23.9232 24.4759 23.3213L24.4668 20.414C24.4572 17.3449 25.4001 14.3119 27.2288 11.53L29.7065 7.76076C29.8461 7.54831 29.8757 7.31653 29.8158 7.09619Z",
    fill: "#D1D1D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.6814 24.4117H17.7371V31.0169H22.6814V24.4117Z",
    fill: "#BABBC0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M29.4386 6.55955L27.8456 5.34663C27.5552 5.12553 27.1484 5 26.7223 5H17.0211C16.561 5 16.1251 5.14633 15.8336 5.39871L14.3006 6.72597C14.1732 6.83629 14.0825 6.96274 14.0246 7.09615H29.8158C29.7624 6.89982 29.6393 6.71239 29.4386 6.55955Z",
    fill: "#BABBC0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.75 18.5017H10.8288V17.201C10.8288 16.7615 10.3269 16.5105 9.97525 16.7743L7.13004 18.9081C6.84557 19.1216 6.84557 19.5483 7.13004 19.7617L9.97525 21.8955C10.3269 22.1593 10.8288 21.9084 10.8288 21.4688V20.1684H12.75C13.2102 20.1684 13.5833 19.7953 13.5833 19.3351C13.5833 18.8749 13.2102 18.5017 12.75 18.5017Z",
    fill: "#898B94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.37 18.9081L30.5248 16.7743C30.1731 16.5105 29.6713 16.7615 29.6713 17.201V18.5017H27.75C27.2894 18.5017 26.9167 18.8749 26.9167 19.3351C26.9167 19.7953 27.2894 20.1684 27.75 20.1684H29.6713V21.4688C29.6713 21.9084 30.1731 22.1593 30.5248 21.8955L33.37 19.7617C33.6545 19.5483 33.6545 19.1216 33.37 18.9081Z",
    fill: "#898B94"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiJoystick);
export default __webpack_public_path__ + "static/media/multi-joystick.a30a1128a6e880d8ea4f81a8dd979e30.svg";
export { ForwardRef as ReactComponent };